export default __webpack_public_path__ + "static/media/solvenciaIcon.3ae99fde.svg";